// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2454":"1112d5966e698430","7398":"e31a0f7faf82375a"}[chunkId] + ".css";
};